import { z } from 'zod';

export const signupSchema = z.object({
  name: z.string().min(1, 'El nombre es requerido'),
  email: z.string().email('Ingresa un correo válido'),
  companyName: z.string().min(1, 'El nombre de empresa es requerido'),
  country: z.string().min(1, 'Selecciona un país'),
  countryPrefix: z.string().optional(),
  cellphone: z.string().min(7, 'Ingresa un número válido'),
  password: z.string().min(6, 'La contraseña debe tener al menos 6 caracteres'),
  confirmPassword: z.string(),
  vendor: z.string().optional(),
  referrer: z.string().optional(),
  acceptedTC: z.boolean().refine(val => val === true, 'Debes aceptar los términos y condiciones'),
  acceptedPP: z.boolean().refine(val => val === true, 'Debes aceptar la política de privacidad'),
}).refine(data => data.password === data.confirmPassword, {
  message: 'Las contraseñas no coinciden',
  path: ['confirmPassword'],
});

export type SignupFormData = z.infer<typeof signupSchema>;
